import React from 'react';
import classes from "./FairPlayModal.module.css";
import { useTranslation } from 'react-i18next';
import { FaXmark } from "react-icons/fa6";

const FairPlayModal = ({setModal}) => {
    const {t}=useTranslation();
    return (
        <div className={classes.container} onClick={() => setModal(false)}>
            <div className={classes.sub_container} onClick={(e) => e.stopPropagation()}>
                <div className={classes.close_btn_container}>

                <button type="button" className={classes.close_btn} onClick={()=>setModal(false)}>
                    <FaXmark className={classes.close_icon} />
                </button>
                </div>
                <div className={classes.msg}>
                    <p className={classes.text}>{t("112")}</p>
                    <p className={classes.text}>{t("113")}</p>
                    <p className={classes.text}>{t("114")}</p>
                    <p className={classes.text}>{t("115")}</p>
                </div>
            </div>
        </div>
    )
}

export default FairPlayModal;